import {
    Common__$,
    Common__domHide,
    Common__domShow,
    Common__domAddClass,
    Common__domRemoveClass,
    Common__debounce,
    Common__domOn,
} from './mi/common';
import {
  Utils__displayShareBar,
  Utils__getShareTarget,
  Utils__isSharePage,
  Utils__checkInitTime,
  utils__Numbershort,
  Utils__getQuery,
  Utils__isMiuiQuickSearchBox,
  Utils__isXiangkan,
  Utils__getImeiMd5,
  Utils__isQuanQiuShangWang,
  Utils__isQuickGame,
} from './utils';
import {
  share__map,
  share__wx,
  share__open,
  shareOpenAppStore
} from './share';
import { Fragment__xiangkanInit } from './mi/fragment';
import { tpl__backfollow } from './mi/tpl';
import { shareTextArr } from './conf';
import stats__send from './stats';
import '../../css/backfollow.css';
import { miDetail__shareTrackExpose } from './mi-detail';
import { api__isXiangkanNews } from './api';

export default function xiangkanDetail(isFirst) {
    const UA = navigator.userAgent || '';
    // 全局搜索、想看资讯、全球上网、快游戏不用初始化
    // 防止 uc 等内容的异步调用
    if (Utils__isMiuiQuickSearchBox() || Utils__isXiangkan(UA) || Utils__isQuanQiuShangWang() || Utils__isQuickGame()) {
      if (Utils__isQuanQiuShangWang()) { // 全球上网默认Webview渲染bug，此处hack
        document.documentElement.getBoundingClientRect();
      }
      return;
    }

    if (!/docid=[^&]/i.test(location.href)) {
        return;
    }

    const query = Utils__getQuery(location.href) || {};
    // 浏览器分享，对于高版本浏览器有参数 share={wechat/qq}&mi_source=miuibrowser，
    // 低版本浏览器无 share/mi_source 参数，默认填充之
    // 内容迁移后，浏览器和想看中某些文章 docid 仍不一致，故无论高低版本，浏览器分享出的统一判断 docid
    if (!query.share || query.mi_source === 'miuibrowser') {
      const docId = Utils__getQuery(location.href).docid;

      api__isXiangkanNews({
        docId: docId,
        imei: Utils__getImeiMd5(),
      }, () => {
        replaceHistory();
        Utils__checkInitTime(xiangkanDetail__init, isFirst);
      }, () => {

        replaceHistory(true);
        Utils__checkInitTime(xiangkanDetail__init, isFirst);
      });
      miDetail__shareTrackExpose(navigator.userAgent || '');
    } else {
      Utils__checkInitTime(xiangkanDetail__init, isFirst);
    }

    function replaceHistory(targetToHome) {
        let url = location.href;

        // 由于下游已使用 source=liulanqi 做判断，故此处暂时兼容，待内容迁移无问题时统一修改
        if (query.mi_source) {
            url = url.replace('mi_source=miuibrowser', 'source=liulanqi');
        } else {
            url = `${url}&share=social&source=liulanqi`;
        }

        if (targetToHome) {
            url += '&target=home';
        }

        // target=home 表示 deeplink 到想看首页，因为想看库中不存在此文章
        history.replaceState(history.state, null, url);
    }
}

const xiangkanDetail__floatHeight = 46;
let _xiangkanDetail__readMoreExposed = false;
let _xiangkanDetail__isInited = false;

function xiangkanDetail__init() {
    if (_xiangkanDetail__isInited) {
        return;
    }
    _xiangkanDetail__isInited = true;
    const UA = navigator.userAgent || '';
    const url = location.href;

    if (_xiangkanDetail__isShouldBackfollowPage()) {
      _xiangkanDetail__setBackfollowPage();
      return;
    }
    if (Utils__displayShareBar(UA, url)) {
        _xiangkanDetail__insertFloatBar();
        _xiangkanDetail__insertDialog();
        _xiangkanDetail__insertReadMore();
        _xiangkanDetail__insertCommetDownBar();
    }

    if (Utils__isSharePage(url)) {
        const shareTarget = Utils__getShareTarget(location.href, share__map);

        // 嵌入iframe，目前内容有相关推荐
        Fragment__xiangkanInit();
        _xiangkanDetail__trackExpose();
    }

    window.addEventListener('message', function (event) {
        const data = event.data;
        const order = data.order;
        const param = data.param;

        switch (order) {
            case 'setIframeHeight':
                Common__$('.xiangkan-detail__iframe').height = param.height + 'px';
                break;
            case 'shareOpen':
                share__open(param.href, '', { title: param.title || '' });
                break;
            case 'shareInfo':
                // 取消升级用户底部头像，用想看的默认头像，用户头像微信不授权
                // _xiangkanDetail__updateShareInfo(param);
            default:
                break;
        }
    });

    document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
            window.hasLeft = true;
        }
    });

    window.shareButtonClick = function(opt) {
      const $xiangkanHelper = Common__$('.xiangkan-detail__share-link-title');

      if ($xiangkanHelper && $xiangkanHelper.innerHTML === '想看小助手') {
        opt.isXiangkanHelper = 1;
      } else {
        opt.isXiangkanHelper = 0;
      }

        xiangkanDetail__postMessage('trackEvent', opt);
        if (opt.type === 'dialog') {
          share__open('', 'xiangkanSpread,share_news_dialog', { title: document.title });
        } else {
          share__open('', '', { title: document.title });
        }
        document.removeEventListener('touchmove', _xiangkanDetail__preventEvent, { passive: false });
    };

    window.expandArticle = _xiangkanDetail__expandArticle;
    window.openReadMoreDialog = _xiangkanDetail__openReadMoreDialog;
}

// 想看导流弹窗
function _xiangkanDetail__insertDialog() {
    const $root = Common__$('#mi-detail');
    const $share = document.createElement("div");

    $share.innerHTML = `
    <div class="xiangkan-detail__app-dialog" >
        <div class="xiangkan-detail__app-dialog-content">
            <img src="http://ts.market.mi-img.com/download/Browser/0617794bd44974a7a2472804cd5f9e4eb55fafcd5/dialog.png"
                onclick="shareButtonClick({name: '自动弹窗引导', action: '点击'})">
            <div class="xiangkan-detail__app-dialog-close" onclick="history.back()"></div>
        </div>
    </div>`;
    $root.insertAdjacentElement('beforebegin', $share);
}

// 想看底部/顶部悬浮窗
function _xiangkanDetail__insertFloatBar() {
    const $root = Common__$('#mi-detail');
    const $wrapper = $root.parentNode;
    const $img = Common__$('img') || {};
    const $share = document.createElement("div");
    const index = Math.floor(Math.random() * shareTextArr.length);
    const text = shareTextArr[index];

    $wrapper.style.marginBottom = xiangkanDetail__floatHeight + 'px'; // 设置底部高度，高度等于悬浮窗

    share__wx({
        title: document.title,
        url: location.href,
        image: $img.src || '',
    });

    $share.innerHTML = `
    <div class="xiangkan-detail__red-packet" onclick="shareButtonClick({name: '红包icon', action: '点击' })"></div>
    <div class="xiangkan-detail__share-link">
        <img class="xiangkan-detail__share-link-logo" src="https://ts.market.mi-img.com/download/Browser/0d61d48bebbac668bb2476b2af13c5e327f40a78a/xiangkan.png"/>
        <div class="xiangkan-detail__share-link-desc">
            <p class="xiangkan-detail__share-link-title">想看资讯</p>
            <p class="xiangkan-detail__share-link-subtitle">发现每日新鲜事</p>
        </div>
        <div class="xiangkan-detail__share-open-btn" onclick="shareButtonClick({name: '底部打开', action: '点击', title: '${text}'})">立即打开</div>
    </div>`;
    $root.insertAdjacentElement('beforebegin', $share);
}

function _xiangkanDetail__openReadMoreDialog() {
  var dialog = document.querySelector('.xiangkan-detail__read-more-dialog');

  xiangkanDetail__postMessage('trackEvent', {
    action: '点击',
    name: '阅读全文',
  });

  if (dialog) {
    xiangkanDetail__postMessage('trackEvent', {
      action: '曝光',
      name: '打开app弹窗',
    });
    Common__domShow(dialog);
  }
  document.addEventListener('touchmove', _xiangkanDetail__preventEvent, { passive: false });
}

/** 想看详情页添加评论下载按钮 */
function _xiangkanDetail__insertCommetDownBar() {
  const $commetDownBar = document.createElement('div');
  const $root = Common__$('#mi-detail-wrapper');

  $commetDownBar.innerHTML = `
    <div class="xiangkan-detail__read-more-btn" onclick="shareButtonClick({name: '评论打开', action: '点击'})">
    </div>
  `;

  $root.appendChild($commetDownBar);
}

/** 想看详情页添加下载APP查看全文按钮 */
function _xiangkanDetail__insertReadMore() {
    const $readMore = document.createElement('div');
    const $root = Common__$('#mi-detail');
    const maxHeight = 1.5 * window.innerHeight + 105; // 一屏半后开始遮罩
    let height;

    insert();

    function compare() {
        height = $root.offsetHeight;
        return (height > maxHeight);
    }

    function insert() {
        if (compare()) {
            $root.style.maxHeight = maxHeight + 'px';

            Common__domAddClass($root, 'mi-detail__hide-article');

            $readMore.innerHTML = `
            <div class="xiangkan-detail__read-more">
              <div class="xiangkan-detail__read-more-expand" onclick="openReadMoreDialog()">
                <div class="xiangkan-detail__read-more_tip">点击阅读全文</div>
                <div class="xiangkan-detail__read-more_expand-btn"></div>
              </div>
              <div class="xiangkan-detail__read-more-dialog" style="display: none;">
                <div>
                  <div>
                      <p class="xiangkan-detail__read-more-dialog-title">想看资讯</p>
                      <P class="xiangkan-detail__read-more-dialog-content">打开APP阅读全文，体验更流畅</p>
                  </div>
                  <div class="xiangkan-detail__read-more-dialog-footer">
                      <span onclick="expandArticle()">取消</span>
                      <span onclick="shareButtonClick({name: '打开app弹窗', action: '点击确定', type: 'dialog' })">确定</span>
                  </div>
                </div>
              </div>
            </div>
            `;
            $root.appendChild($readMore);
        }
    }
}

function _xiangkanDetail__updateShareInfo(options = {}) {
  // var commentCount = options.commentCount;
  var sharedBy = options.sharedBy || {};
  // var comment = Common__$('.xiangkan-detail__read-more-commentCount');
  var shareUserName = Common__$('.xiangkan-detail__share-link-title');
  var shareUserIcon = Common__$('.xiangkan-detail__share-link-logo');
  /*
  if (comment && commentCount) {
    comment.innerHTML = '共' + utils__Numbershort(commentCount) + '条评论，打开想看APP查看';
  }
  */

  if (shareUserIcon && sharedBy.headIcon) {
    shareUserIcon.src = sharedBy.headIcon;
  }

  if (shareUserName && sharedBy.nickname) {
    shareUserName.innerHTML = sharedBy.nickname;
  }

}

/** 想看阅读全文点击*/
function _xiangkanDetail__expandArticle() {
    const $root = Common__$('#mi-detail');

    Common__domHide(Common__$('.xiangkan-detail__read-more'));
    Common__domRemoveClass($root, 'mi-detail__hide-article');
    $root.style.maxHeight = 'none';

    xiangkanDetail__postMessage('trackEvent', {
      action: '点击取消',
      name: '打开app弹窗',
    });

    xiangkanDetail__postMessage('trackEvent', {
        action: '点击',
        name: '阅读全文',
    });
    document.removeEventListener('touchmove', _xiangkanDetail__preventEvent, { passive: false });
}

function _xiangkanDetail__preventEvent(e) {
    e.preventDefault();
}

function _xiangkanDetail__trackExpose() {
    const param = {
        height: window.innerHeight - xiangkanDetail__floatHeight,
    };
    /*
    let dialogShowed = sessionStorage.getItem('dialog-showed');

    if (location.hash === '#dialog') {
        history.back();
    }
    */

    window.addEventListener('scroll', Common__debounce(function() {
        const $readMoreBtn = Common__$('.xiangkan-detail__read-more-btn');
        const $readMore = Common__$('.xiangkan-detail__read-more');
        let rect;

        if ($readMoreBtn) {
            rect = $readMoreBtn.getBoundingClientRect();
        }

        if ($readMoreBtn && rect.top >= 0 && rect.bottom <= param.height && !_xiangkanDetail__readMoreExposed) {
            _xiangkanDetail__readMoreExposed = true;

            xiangkanDetail__postMessage('trackEvent', {
                action: '曝光',
                name: '评论打开',
            });

            // 阅读全文的曝光用它底部的评论按钮算的、不够精确、但是少了一次结算rect,接受误差
            if ($readMore) {
                xiangkanDetail__postMessage('trackEvent', {
                    action: '曝光',
                    name: '点击阅读全文',
                });
            }
        }

        param.top = Common__$('.xiangkan-detail__iframe').getBoundingClientRect().top;

        xiangkanDetail__postMessage('trackExpose', param);
    }, 250), true);
}

export function xiangkanDetail__postMessage(order, param) {
    window.frames['xiangkan-detail__iframe'].postMessage({
        order: order,
        param: param,
    }, '*');
}

function _xiangkanDetail__isShouldBackfollowPage() {
    return location.href.indexOf('backfollow=1') > -1;
}

function _xiangkanDetail__setBackfollowPage() {
  if (_xiangkanDetail__isShouldBackfollowPage()) {
    document.body.innerHTML = tpl__backfollow();
    const backfollowBtn = Common__$('.backfollow__open');
    const sendCallback = function () {
      share__open('', 'xiangkanSpread,share_back');
    };

    Common__domOn(backfollowBtn, 'click', function () {
      stats__send({
        cate: '分享页',
        action: '点击',
        name: 'back中间页',
      }, sendCallback, sendCallback);
    });
  }
}
